import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui'
// import {
//     valiSecureCode
// } from './validate'

// 创建一个 Loading 实例
let loadingInstance = '';

let requestCount = 0; // 请求计数器

// 显示加载动画
function showLoading() {
  if (requestCount === 0) {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  requestCount++;
}

// 隐藏加载动画
function hideLoading() {
  requestCount--;
  if (requestCount === 0) {
    loadingInstance.close();
  }
}
const axiosIns = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
})
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

console.log("当前运行环境：" + process.env.NODE_ENV)
if (process.env.NODE_ENV == 'development') { // 开发环境
  // axiosIns.defaults.baseURL = 'https://duegin.mynatapp.cc/EPM-CORE-SERVICE' //锋'http://192.168.19.216:31000/EPM-CORE-SERVICE' //'http://crazydota.51vip.biz' //'http://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'//'http://laughign.free.idcfengye.com' //  //'http://192.168.101.41:31003/'
  axiosIns.defaults.baseURL = 'http://192.168.19.216:31000/EPM-CORE-SERVICE' //锋'http://192.168.19.216:31000/EPM-CORE-SERVICE' //'http://crazydota.51vip.biz' //'http://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'//'http://laughign.free.idcfengye.com' //  //'http://192.168.101.41:31003/'
  // axiosIns.defaults.baseURL = 'http://192.168.2.104:31000/EPM-CORE-SERVICE' //锋'http://192.168.19.216:31000/EPM-CORE-SERVICE' //'http://crazydota.51vip.biz' //'http://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'//'http://laughign.free.idcfengye.com' //  //'http://192.168.101.41:31003/'
  // axiosIns.defaults.baseURL = 'http://epm.tentcoo.com/gateway/EPM-CORE-SERVICE' //'http://192.168.19.216:31000/EPM-CORE-SERVICE' //'http://crazydota.51vip.biz' //'http://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'//'http://laughign.free.idcfengye.com' //  //'http://192.168.101.41:31003/'
  // axiosIns.defaults.baseURL = 'http://192.168.21.26:41002/gateway/EPM-CORE-SERVICE' //'http://192.168.19.216:31000/EPM-CORE-SERVICE' //'http://crazydota.51vip.biz' //'http://epm.tentcoo.com:31000/EPM-CORE-SERVICE/'//'http://laughign.free.idcfengye.com' //  //'http://192.168.101.41:31003/'
} else if (process.env.NODE_ENV === 'testing') { // 测试环境
  axiosIns.defaults.baseURL = '/gateway/EPM-CORE-SERVICE'
  // axiosIns.defaults.baseURL = 'https://test.epm.tentcoo.com:31000/EPM-CORE-SERVICE'
} else if (process.env.NODE_ENV == 'production') { // 生产环境
  axiosIns.defaults.baseURL = 'https://epm.tentcoo.com/gateway/EPM-CORE-SERVICE' // 'http://47.106.196.230:21000'
}
// axiosIns.defaults.baseURL = window.NODE_ENV

// const XAuthorization = 'X-Authorization'
const jwtToken = 'jwtToken'
axiosIns.interceptors.request.use(function (config) {

  if (config.owner === 'EPM-CORE-SERVICE') {
    // config.baseURL = config.baseURL + '/EPM-CORE-SERVICE/'
  } else if (config.owner === 'EPM-BASE-SERVICE') {
    // config.baseURL = config.baseURL + '/EPM-BASE-SERVICE/'
  } else {
    // config.baseURL = config.baseURL + '/EPM-CORE-SERVICE/'
  }

  let token = localStorage.getItem('jwtToken')
  if (token) {
    // config.headers[XAuthorization] = token
    config.headers[jwtToken] = token
  } else {
    // delete config.headers[XAuthorization]
    delete config.headers[jwtToken]
  }

  if(typeof config.isShowLoading === 'undefined' || config.isShowLoading) {
    showLoading();
  }
  return config
})

axiosIns.interceptors.response.use(function (response) {
  let data = response.data
  let code = data.code
  // console.log("response", response)
  // return Promise.resolve(data) // 先直接返回数据
  if(typeof response.config.isShowLoading === 'undefined' || response.config.isShowLoading) {
    hideLoading();
  }
  if (code && code.toString().indexOf(2) === 0) { // 字符串才 indexOf
    Message({
      //message: data.msg + ':' + data.data + '即将自动返回登录页面。',
      message: data.msg + ':' + '即将自动返回登录页面。',
      type: 'error',
      duration: 5 * 1000
    })
    setTimeout(() => {
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('currentUser')
      location.replace(location.origin + '#/login')
    }, 5000)
  } else if (code && code === 1000) { // 操作成功
    return Promise.resolve(data)
  } else if (code && code === 1001) { // 响应失败
    Message({
      message: data.msg + ':' + data.data,
      type: 'warning',
      duration: 5 * 1000
    })
    return Promise.resolve(data)
  } else if (code && code === 1002) { // 参数校验失败
    Message({
      message: data.msg + ':' + data.data,
      type: 'warning',
      duration: 5 * 1000
    })
    return Promise.reject(data)
  } else if (code && code === 1003) { // 远程服务调用失败
    Message({
      message: data.msg + ':' + data.data,
      type: 'warning',
      duration: 5 * 1000
    })
    return Promise.reject(data)
  } else if (code && code === 1005) { // 数据持久化失败
    Message({
      message: data.msg + ':' + data.data,
      type: 'warning',
      duration: 5 * 1000
    })
    return Promise.reject(data)
  } else if (code && code === 5000) { // 未知错误
    Message({
      message: data.msg + ':' + data.data,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(data)
  } else if (status && status === "500") {
    Message({
      message: 'code:' + status + 'msg:' + error,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(data)
  } else {
    let str = response.headers['content-disposition'] || ''
    let index = str.lastIndexOf('=')
    let fileName = str.substring(index + 1, str.length)
    return Promise.resolve({
      fileName,
      data: response.data
    })
  }
}, function (err) {
  Message({
    message: err,
    type: 'error',
    duration: 5 * 1000
  })
  hideLoading();
  return Promise.reject(err.response.data)
})

export default axiosIns



// WEBPACK FOOTER //
// ./src/utils/axios.js